export const DEFAULT_LANG = 'en';
export const DEFAULT_DATE_FORMAT = '%d-%m-%Y';
export const DEFAULT_DATE_FORMAT_DM = '%d %M';
export const DEFAULT_DATE_FORMAT_W = '%W';
export const DEFAULT_DATE_FORMAT_M = '%M';
export const DEFAULT_DATE_FORMAT_FY = '%F, %Y';
export const DEFAULT_DATE_FORMAT_MY = '%M %y';
export const DEFAULT_DATE_FORMAT_Y = '%Y';
export const DEFAULT_COLUMN_WIDTH_PX = 80;

export enum EDataCellId {
    TimelineCell = 'ganttTimelineCol',
    GridTableCell = 'ganttGridCol',
    TimelineContainer = 'ganttContainer',
    ScrollXControl = 'ScrollXControl',
}

export enum EDataCellSelectors {
    TimelineRowsContainer = '.gantt_task',
    TableRowsContainer = '.gantt_grid_data',
    TimelineRowsDataArea = '.gantt_data_area',
    TimelineRowsDataLayerId = 'datalayer',
    DeadLinesId = 'dead_lines_',
    QuickInfo = '.gantt_cal_quick_info',
}

export enum EDateScaleValue {
    Day = 1,
    Week = 2,
    Month = 3,
    Quarter = 4,
    Years = 5,
    Decade = 6,
}

export enum ETimelineColumnAlign {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}

export enum EContextMenuEvents {
    Add = 'add',
    Edit = 'edit',
    Remove = 'remove',
    ReloadData = 'ReloadData',
}

export enum ETimelineOutputEvents {
    AddRow = 'addRow',
    EditRow = 'editRow',
    RemoveRow = 'removeRow',
    ChangePosition = 'changePosition',
}

export enum EQuickInfoButtons {
    Delete = 'delete',
    Edit = 'edit',
}

export enum ETimelineRowDragEvents {
    Insert = 'insert',
    After = 'after',
}

export const TIMELINE_NOTIFY_PREFIX = 'timeline_notify_';

export enum ETimelineNotifyType {
    Warning = 'warning',
}

export enum ECustomClasses {
    /** Вешаем этот класс, если элемент есть в реестре, но его нет в дереве */
    NotUseInTree = 'not-used',
    /** Вешаем этот класс, если под элементом будут располагаться сроки */
    Slim = 'slim',
    /** Вешаем этот класс, если факт окончание больше чем планируемое задачи */
    DeadlineExceeded = 'deadline_exceeded',
    TaskCellOverdue = 'overdue_cell',
}

export enum ETimelineMarkers {
    Today = 'todayMarker',
}

export enum ETasksTypes {
    Task = 'task',
    Project = 'project',
}
